import { useCallback } from "react";
import { money, sumCents, lineTotalInc } from "../money.js";

/**
 * A racket build: the racket, then its string / overgrip / add-on lines nested
 * under it, with one subtotal for the whole build. The lines stay separate
 * WooCommerce products (real price, stock, order lines) — this only groups the
 * display. Quantity is locked to 1 (server: Configurator\BuildGroup); "Remove"
 * takes the whole build out.
 */
export default function CartBuild({ group, busy, onRemoveBuild }) {
	const { racket, extras } = group;
	const primary = racket || extras[0];
	if (!primary) return null;

	const img = primary.images?.[0];
	const name = racket ? racket.name : primary.name;
	const variation = racket?.variation
		?.map((v) => v.value)
		.filter(Boolean)
		.join(" · ");

	const spec = (racket?.item_data || []).filter(
		(d) => d.value && d.key !== "Part of",
	);

	const lines = [racket, ...extras].filter(Boolean);
	const t = primary.totals;
	const subtotal = money(sumCents(lines.map(lineTotalInc)), t);
	const allKeys = lines.map((it) => it.key);

	const remove = useCallback(() => onRemoveBuild(allKeys), [allKeys, onRemoveBuild]);

	return (
		<div className={`zc-card zc-build${busy ? " is-busy" : ""}`}>
			<div className="zc-card__top">
				<div className="zc-card__media">
					{img ? (
						<img src={img.thumbnail || img.src} alt={img.alt || name} loading="lazy" />
					) : (
						<div className="zc-card__media-ph" />
					)}
				</div>

				<div className="zc-card__body">
					<span className="zc-build__badge">Racket build</span>
					<span className="zc-card__name">{name}</span>
					{variation && <span className="zc-card__sub">{variation}</span>}

					{spec.length > 0 && (
						<dl className="zc-build__spec">
							{spec.map((d, i) => (
								<div key={i}>
									<dt>{d.key}</dt>
									<dd dangerouslySetInnerHTML={{ __html: d.value }} />
								</div>
							))}
						</dl>
					)}
				</div>

				<div className="zc-card__aside">
					<span className="zc-card__price">{subtotal}</span>
					<button
						type="button"
						className="zc-card__remove"
						onClick={remove}
						disabled={busy}
						aria-label={`Remove ${name} build`}
					>
						Remove
					</button>
				</div>
			</div>

			{extras.length > 0 && (
				<ul className="zc-build__extras">
					{extras.map((it) => (
						<li key={it.key}>
							<span>{it.name}</span>
							<span>{money(lineTotalInc(it), it.totals)}</span>
						</li>
					))}
				</ul>
			)}
		</div>
	);
}
